import {createContext, useEffect, useState} from "react";
import WorkScheduleService from "../../../../../../../../services/web/work-schedule-service.js";
import {getEndOfDay, getStartOfDay, toLocalDate, workScheduleSpecialCases} from "../../../utils/work-schedule-utils.js";
import {useSearchParams} from "react-router";
import {format} from "date-fns";
import moment from "moment";


export const WorkScheduleContext = createContext(undefined);
const WorkScheduleProvider = ({children}) => {
    const [searchParams] = useSearchParams();
    const cp = searchParams.get("cp");
    const nameParam = searchParams.get("name");
    const dtStartParam= searchParams.get("dtStart");
    const dtEndParam = searchParams.get("dtEnd");
    const [droppedItems, setDroppedItems] = useState(Array(7).fill(null).map(() => []));
    const [name, setName] = useState(nameParam ? nameParam : "");
    const [startDate, setStartDate] = useState(dtStartParam ? new Date(dtStartParam) : null);
    const [endDate, setEndDate] = useState( dtEndParam ? new Date(dtEndParam) : null);
    const [teams, setTeams] = useState([]);
    const [previewTeams, setPreviewTeams] = useState([]);
    const [teamsToSend, setTeamsToSend] = useState([]);
    const [isDragging, setIsDragging] = useState(false);

    useEffect(() => {
        const loadInitialData = async () => {
            try {
                const teamsToOrder = await fetchTeams();
                const rawTeamsData = teamsToOrder.sort((a,b) => a.name.localeCompare(b.name));
                let currentWorkScheduleData = null;

                if (cp) {
                    const {data: wsData} = await WorkScheduleService.getWorkSchedule(Number(cp));
                    currentWorkScheduleData = wsData;
                }

                if (cp && currentWorkScheduleData?.teamsToShow) {
                    handleSelectPreviewWorkSchedule(cp, rawTeamsData)
                }
                setTeams(rawTeamsData);

            } catch (error) {
                console.error("Erro ao carregar dados iniciais:", error);
            }
        };

        loadInitialData();
    }, []);

    const handleSelectPreviewWorkSchedule = (scheduleId, teams) => {
        const dataToSend = {
            id: Number(cp),
            startPeriod: getStartOfDay(startDate).toISOString(),
            endPeriod: getEndOfDay(endDate).toISOString()
        };

        WorkScheduleService.calculateFromAnotherSchedule(dataToSend)
            .then(async ({data}) => {
                const filledSchedule = [];

                for (const item of data) {
                    const filled = await fillSchedule(item, item.period, format(startDate, "yyyy-MM-dd"), teams);
                    console.log("filled", filled)
                    filledSchedule.push(filled)
                }
                setTeamsToSend(filledSchedule);
            })
            .catch(error => {
                console.error(error);
            });
    }

    const fetchTeams = async () => {
        const response = await WorkScheduleService.listTeams()
        const data = response.data;
        const transformedDate = await calculateAllSchedules(data)
        return transformedDate ?? [];
    }

    async function calculateAllSchedules(rawTeamsData)  {
        if (!rawTeamsData || rawTeamsData.length === 0) {
            return [];
        }

        try {
            const teamsToQuery = rawTeamsData.filter(team => !workScheduleSpecialCases.some(scale => scale.id === team.scale));

            const requests = teamsToQuery.map(team => {
                return WorkScheduleService.calculateScheduleTurns({
                    journeyPattern: team.scale,
                    startTime: team.startHour
                }).then(response => {
                    return {...team, turnInitialHour: response.data.length > 1 ? "-" : team.startHour, schedule: response.data};
                });
            });

            const results = await Promise.all(requests);

            const commercialTeams = rawTeamsData
                .filter(team => workScheduleSpecialCases.some(scale => scale.id === team.scale))
                .map(team => ({...team, turnInitialHour: team.startHour, schedule:[ {endTime: team.endtHour, startTime: team.startHour}]}));

            return [...results, ...commercialTeams];
        } catch (err) {
            console.error("Falha ao calcular schedules:", err);
            return [];
        }
    };

    // useEffect( () => {
    //     const fetchTeams = async () => {
    //         const response = await WorkScheduleService.calculateSchedule({
    //
    //         })
    //         const data = response.data;
    //         const transformedDate = await calculateAllSchedules(data)
    //         if(data.length > 0)
    //             setTeams(transformedDate);
    //     }
    //     fetchTeams()
    // }, []);

    useEffect(() => {
        if (teamsToSend.length === 0) return;

        const dataToSend = {
            teams: teamsToSend,
            startPeriod: getStartOfDay(startDate).toISOString(),
            endPeriod: getEndOfDay(endDate).toISOString()
        };

        WorkScheduleService.calculateSchedule(dataToSend)
            .then(({data}) => {
                const newPreviewTeams = [...data];
                setPreviewTeams(newPreviewTeams);
            });
    }, [teamsToSend]);

    const handleDrop = async (e, day) => {
        e.preventDefault();
        const { team, period } = JSON.parse(e.dataTransfer.getData("json/application"));

        const filled = await fillSchedule(team, period, day, teams);
        setTeamsToSend([...teamsToSend, {...filled}]);
    }

    async function fillSchedule (team, period, day, teams) {
        const isoString = new Date(day).getTime();

        const newDroppedItems = { ...droppedItems };

        if (!newDroppedItems[isoString]) {
            newDroppedItems[isoString] = [];
        }

        const teamExists = newDroppedItems[isoString].some(item => item.id === team.id);
        if (teamExists) {
            newDroppedItems[isoString] = newDroppedItems[isoString].map(item =>
                item.id === team.id ? { day, teamId: team.id, team: JSON.stringify(team), period, color: team.color } : item
            );
        } else {
            newDroppedItems[isoString].push({ day, teamId: team.id, team: JSON.stringify(team), period, color: team.color });
        }

        const find = teams.find(item => item.id === team.id);

        let updateTeams;

        if (find) {
            find.period = period;
            if (find.id === team.id) {
                find.dayOfStart = new Date(day).toISOString();
            }

            updateTeams = find;

            setTeams((prevItems) =>
                prevItems.map((item) =>
                    item.id === find.id ?
                        {...item, processed: true}
                        : item
                )
            );
        }

        [...document.getElementsByClassName("day")].forEach(i => i.classList.remove("drop-area"));

        return updateTeams;
    }

    const removeItem = (teamToRemove) => {
        setTeams((prevItems) =>
            prevItems.map((item) => {
                    return item.id === teamToRemove.id ?
                        {...item, processed: false, turnInitialHour: item.schedule.length > 1 ? "-" : item.schedule[0].startTime}
                        : item
                }
            )
        );

        const newItems = (prevItems) => prevItems.filter(item => item.id !== teamToRemove.id);
        setPreviewTeams(newItems)
        setTeamsToSend(newItems)

        const newDroppedItems = { ...droppedItems };

        Object.keys(newDroppedItems).forEach(idx => {
            const index = newDroppedItems[idx].findIndex(ite => ite.id === teamToRemove.id);
            if (index !== -1) newDroppedItems[idx].splice(index, 1);
        });

        setDroppedItems(newDroppedItems);
    }

    const removeAll = () => {
        previewTeams.forEach(el => removeItem(el));
    }

    return(
        <WorkScheduleContext.Provider value={{
            teams, setTeams, startDate, setStartDate, endDate, setEndDate, previewTeams, teamsToSend, setTeamsToSend, handleDrop, isDragging, setIsDragging,
            removeItem, removeAll, searchParams, name, setName
        }}>
            {children}
        </WorkScheduleContext.Provider>
    )
}

export default WorkScheduleProvider